module.exports = __webpack_public_path__ + "media/images/instagram-color-30e86452f3c87942fb7c03d696074941.png";